<template>
    <v-container class="pa-0 ma-0" id="mainhomecontainer">
        <v-card class="overview" elevation="0">
            <v-card-title class="pa-0">
                <v-container style="min-height:200px;" class="topbg">
                <v-row>
                    <v-col
                    cols="12"
                    md="12"
                    color="white--text"
                    class="text-center mt-5 mb-5"
                    style="color:#fff;"
                    >
                    FREE BUSINESS
                    <br />
                    <span class style="font-size:16px;">USER ACCOUNT</span>
                    </v-col>
                </v-row>
                </v-container>

                <v-row class="pwa-content">
                <v-col cols="12" md="12" class="text-center">
                    <img :src="juzzapLogo" width="100" />
                </v-col>
                </v-row>
            </v-card-title>

            <v-card-text>
                <v-row>
                    <v-col cols="12" class="text-center" style="font-size:16px;">
                        Our Simple Terms & Conditions<br> 3 minute read
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" class="text-center"> 
                        As if you do not already have enough on your plate to deal with some will keep this short, sharpe and sweat.
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" class="text-center"> 
                        Even though we are new startup with just three in the team we know we can help millions of business owners with our products and services.
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" class="text-center"> 
                        We are not out to make money we are out to make a differance, a positive one, and we know if we do a good job the money will come!
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" class="text-center">
                        So, our terms and conditions are simple; 
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" class="text-center">
                        We, Juzzap will always do what what we do to the very best of our abilities at all times but if we mess up in anywau with our service you agree not to suit us or hold us liable for any loss that you may incurr as a result of us getting something wrong. 
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" class="text-center">
                        Lets play nicely.<br>
                        you already have our word about how we will do our best but its a two way street, so you also need to do your bit by agreeing to the following.
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" class="text-center">
                        No positive copyright protected image or text 
                    </v-col>
                    <v-col cols="12" class="text-center">
                        No nudity
                    </v-col>
                    <v-col cols="12" class="text-center">
                        No offensive text or images
                    </v-col>
                    <v-col cols="12" class="text-center">
                        Protect your log in details and not share with anoyone else Only hack us if you want to help us improve your platform <br> 
                        Please dont webscrape our domain or any of the other miriard of data harvesting techniwues
                    </v-col>
                    <v-col cols="12" class="text-center">
                        IF WE GET IT FREE SO DO YOU!
                    </v-col>
                    <v-col cols="12" class="text-center">
                        We will not charge uou for as long as we can!
                    </v-col>
                    <v-col cols="12" class="text-center">
                        But we can only give our products or services for free while we have the help of the companies who provide Juzzap wtih the product and service for free
                    </v-col>
                    <v-col cols="12" class="text-center">
                        Thankfully Amazon Web Services have very kindly provided us with some free services for a limited period of time, for which we are extreamly greatful and we must mention YCombinator who actually put us in touch with Amazon at the end of last Year! BIG shout to both!
                    </v-col>
                    <v-col cols="12" class="text-center">
                        So it work like this, everytime you and your customer uses, Juzzap is uses up data the same as your mobile phone data allowance(if you have it).

                    </v-col>
                    <v-col cols="12" class="text-center">
                        For now we have a large amount of FREE DATA from AWS but this will get used up quickly, when this happens we can do two things 
                    </v-col>
                    <v-col cols="12" class="text-center">
                        1. We will change the way your menu displayed on the screen, It will just have text,no images(they take lot of,even when correctley compressed and resized)
                        and we will remove all extra features like special offers,chefs special and filtering. This will help reduce data usage but still show your menu
                        to your customers.
                    </v-col>
                    <v-col cols="12" class="text-center">
                        2. You can pay us £30.00 per month which we hope will cover cost of all your data usage and (hopefully)
                        we will some to use to carry on making new features and paying our share of the apartment rent(we all work from home to save money)

                    </v-col>
                    <v-col cols="12" class="text-center">
                        Listen things will return to normal in the coming weeks and we will all be of, it may be a bit difficult but if we work 
                        together we can not only get through this but go on to strive.
                    </v-col>
                    <v-col cols="12" class="text-center">
                        if youwant to give your best shot click below to agree to with us however, if you feel its to much of a risk we understand
                        and wish you the greatest of success and hope that when we get up and running you'll give us another short. 
                    </v-col>
                    <v-col cols="12" class="text-center">
                        <a>CLICK HERE TO ACCEPT</a>
                    </v-col>
                </v-row>

            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import Vue from 'vue'
export default {
     props: {
    source: String
  },
  data: () => ({
    juzzapLogo: require("@/assets/logo-Copy.png"),

  }),
}
</script>
<style scoped>
.p-10 {
  padding: 10px;
}
.pwa-content {
  margin-top: -63px;
}
#mainhomecontainer.container {
  width: 100%;
  max-width: 100%;
}
#mainhomecontainer.container .heading {
  color: #fff;
}
.topbg {
  background: #fe5800;
}
</style>